import { set, get, remove } from '../storage';

const STORAGE_KEY = 'data-filling-hint:closed';

export function isClosed() {
  return get(STORAGE_KEY) === true;
}

export function setClose(value) {
  set(STORAGE_KEY, value);
}

export function refresh() {
  remove(STORAGE_KEY);
}
